import { ArnConnectorFactory } from './ArnConnectorFactory';
import { Web3ModalV2Connector } from './web3modal-v2';
import { Web3ModalConnector } from './web3modal';
import { ArnConnector, ArnConnectorType } from '@arianee/arn-types';

export class DefaultConnectorFactory implements ArnConnectorFactory {
  create(connectorType: ArnConnectorType, options: any): ArnConnector {
    switch (connectorType) {
      case ArnConnectorType.Web3Modal:
      case ArnConnectorType.AAT:
        return new Web3ModalConnector(options);
      default:
        return new Web3ModalV2Connector(options);
    }
  }
}
